module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/ExtremelyHotDay/Tokyo_ExtremelyHotDay_MRI_RCP85_End.png";